namespace $ {
	$mol_style_define($ink_currency_select, {
		Filter: {
			flex: { grow: 1 },
		},
		Item: {
			gap: $mol_gap.block,
			justifyContent: 'space-between',
		},
		Item_name: { flex: { shrink: 1 } },
	})
}
